import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import useSeries from 'hooks/useSeries';
import { nextQuestionSelector, questionIndexSelector } from 'config/selectors';

import QuestionWrapper from 'components/QuestionWrapper';
import EndOfSerie from 'components/EndOfSerie';


const Serie = ({id}) => {
  const serie = useSeries(Number(id));
  const questionId = useSelector(nextQuestionSelector);
  const questionIndex = useSelector(questionIndexSelector(questionId));
  return (
    <div className="container">
      {questionId !== -1 ?
      <QuestionWrapper id={questionId} serieId={id} index={questionIndex}/>
      :
      <EndOfSerie serieId={id} />
      }
    </div>
  );
}

export default Serie;